const DAY_MS = 24 * 60 * 60 * 1000;

export const CONVERSATION_AGE_GROUPS = [
  { key: "last7Days", label: "Last 7 Days", maxAgeDays: 7 },
  { key: "last14Days", label: "Last 14 Days", maxAgeDays: 14 },
  { key: "last30Days", label: "Last 30 Days", maxAgeDays: 30 },
  { key: "last60Days", label: "Last 60 Days", maxAgeDays: 60 },
  { key: "olderThan60", label: "60+ Days", maxAgeDays: Infinity },
];

export function parseConversationTimestamp(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "number") {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
  if (dateOnly) {
    return new Date(
      Number(dateOnly[1]),
      Number(dateOnly[2]) - 1,
      Number(dateOnly[3])
    );
  }

  let normalized = trimmed;
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(normalized)) {
    normalized = normalized.replace(" ", "T");
  }
  if (
    /^\d{4}-\d{2}-\d{2}T/.test(normalized) &&
    !/[zZ]$/.test(normalized) &&
    !/[+-]\d{2}:?\d{2}$/.test(normalized)
  ) {
    normalized += "Z";
  }

  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

function calendarDaysBefore(today, date) {
  const todayUtc = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const dateUtc = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return Math.round((todayUtc - dateUtc) / DAY_MS);
}

function timestampMs(conversation) {
  const date = parseConversationTimestamp(conversation.timestamp);
  return date ? date.getTime() : Number.NEGATIVE_INFINITY;
}

export function groupConversations(conversations, now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const groups = {};
  CONVERSATION_AGE_GROUPS.forEach((group) => {
    groups[group.key] = [];
  });

  (conversations || []).forEach((conversation) => {
    const date = parseConversationTimestamp(conversation.timestamp);
    const ageDays =
      date == null ? Infinity : calendarDaysBefore(today, date);
    const bucket =
      CONVERSATION_AGE_GROUPS.find((group) => ageDays <= group.maxAgeDays) ||
      CONVERSATION_AGE_GROUPS[CONVERSATION_AGE_GROUPS.length - 1];
    groups[bucket.key].push(conversation);
  });

  CONVERSATION_AGE_GROUPS.forEach((group) => {
    groups[group.key].sort((a, b) => timestampMs(b) - timestampMs(a));
  });

  return groups;
}
